import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTasks, faTh } from '@fortawesome/pro-light-svg-icons'

import { DashboardModule, Link } from '@domain-group/suit-theme'

import type { UseCampaignImagesPayload } from '../../hooks/useCampaignImages'

import GridView from './GridView'
import ListView from './ListView'

interface GalleryProps {
  campaignImagesPayload: UseCampaignImagesPayload,
}

const Gallery = (props: GalleryProps) => {
  const { campaignImagesPayload } = props

  const {
    callbacks: { toggleView },
    isGridView,
  } = campaignImagesPayload

  // will change once grid has been implemented
  const Component = isGridView ? GridView : ListView

  return (
    <DashboardModule
      boxProps={{ marginBottom: 'large' }}
      headerRight={(
        <Link onClick={() => toggleView()} textProps={{ fontSize: 'small' }}>
          <FontAwesomeIcon icon={isGridView ? faTasks : faTh} />{' '}
          {isGridView ? 'List View' : 'Grid View'}
        </Link>
      )}
      title="Media"
    >
      <Component campaignImagesPayload={campaignImagesPayload} />
    </DashboardModule>
  )
}

export default Gallery
